import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../../services/api';
import { Clock, CheckCircle, XCircle, ChefHat } from 'lucide-react';
import toast from 'react-hot-toast';
import './Cozinha.css';

const Cozinha = () => {
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const queryClient = useQueryClient();

  // Atualizar a cada 5 segundos
  const { data, refetch } = useQuery(
    'pedidos-cozinha',
    async () => {
      const response = await api.get('/api/pedidos?status=Em preparo,Confirmado');
      return response.data.data.pedidos;
    },
    {
      refetchInterval: 5000
    }
  );

  const updateStatusMutation = useMutation(
    ({ id, status }) => api.patch(`/api/pedidos/${id}/status`, { status }),
    {
      onSuccess: () => {
        toast.success('Status atualizado!');
        queryClient.invalidateQueries('pedidos-cozinha');
      }
    }
  );

  const pedidosFiltrados = data?.filter(pedido => {
    if (filtroStatus === 'todos') return true;
    return pedido.status === filtroStatus;
  }) || [];

  const pedidosUrgentes = pedidosFiltrados.filter(p => {
    const tempoEspera = Math.floor((new Date() - new Date(p.createdAt)) / 60000);
    return tempoEspera > 20; // Mais de 20 minutos
  });

  return (
    <div className="cozinha-page">
      <div className="page-header">
        <div>
          <h2><ChefHat size={28} /> Painel de Cozinha</h2>
          <p>Gerencie os pedidos em preparo</p>
        </div>
        <div className="filtros-cozinha">
          <select
            value={filtroStatus}
            onChange={(e) => setFiltroStatus(e.target.value)}
            className="select-status"
          >
            <option value="todos">Todos</option>
            <option value="Confirmado">Confirmados</option>
            <option value="Em preparo">Em Preparo</option>
          </select>
        </div>
      </div>

      {pedidosUrgentes.length > 0 && (
        <div className="alert-urgente">
          ⚠️ {pedidosUrgentes.length} pedido(s) aguardando há mais de 20 minutos!
        </div>
      )}

      <div className="pedidos-grid-cozinha">
        {pedidosFiltrados.map(pedido => {
          const tempoEspera = Math.floor((new Date() - new Date(pedido.createdAt)) / 60000);
          const isUrgente = tempoEspera > 20;

          return (
            <div key={pedido._id} className={`pedido-card-cozinha ${isUrgente ? 'urgente' : ''}`}>
              <div className="pedido-header-cozinha">
                <div>
                  <h3>Pedido #{pedido.numero}</h3>
                  <p className="cliente-nome">{pedido.cliente?.nome}</p>
                </div>
                <div className="tempo-espera">
                  <Clock size={20} />
                  <span>{tempoEspera} min</span>
                </div>
              </div>

              <div className="itens-pedido">
                {pedido.itens?.map((item, idx) => (
                  <div key={idx} className="item-pedido">
                    <span className="quantidade">{item.quantidade}x</span>
                    <span className="nome-produto">{item.produto?.nome || 'Produto'}</span>
                    {item.observacoes && (
                      <span className="observacao">({item.observacoes})</span>
                    )}
                  </div>
                ))}
              </div>

              {pedido.observacoes && (
                <div className="observacoes-pedido">
                  <strong>Obs:</strong> {pedido.observacoes}
                </div>
              )}

              <div className="acoes-pedido">
                {pedido.status === 'Confirmado' && (
                  <button
                    className="btn btn-primary"
                    onClick={() => updateStatusMutation.mutate({ id: pedido._id, status: 'Em preparo' })}
                  >
                    Iniciar Preparo
                  </button>
                )}
                {pedido.status === 'Em preparo' && (
                  <button
                    className="btn btn-success"
                    onClick={() => updateStatusMutation.mutate({ id: pedido._id, status: 'Pronto' })}
                  >
                    <CheckCircle size={20} />
                    Marcar Pronto
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {pedidosFiltrados.length === 0 && (
        <div className="empty-state">
          <ChefHat size={64} />
          <p>Nenhum pedido no momento</p>
        </div>
      )}
    </div>
  );
};

export default Cozinha;

